// extracted by mini-css-extract-plugin
module.exports = {"form":"form___3fGGB","disclaimer":"disclaimer___j4kX9","error":"error___4CtMG"};